import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { IIcon } from '../icon/icon.interface';
import { IconSizesEnum } from '../icon/icons-sizes.enum';

@Component({
  selector: 'app-progress-bar',
  templateUrl: 'progress-bar.component.html',
  styleUrls: ['progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent implements OnInit {
  @Input() value: number = 0;

  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  icon: IIcon;

  constructor() {}

  ngOnInit() {
    this.icon = {
      name: 'close',
      size: IconSizesEnum.small,
    };
  }

  onCancelItem() {
    this.onCancel.emit();
  }
}
